/* Expected to be expanded in the future with e.g. 'driverApp' */
export enum AllowCreatingNewUnmatchedRequestsTypes {
  AdminPanel = 'adminPanel',
  RiderApp = 'riderApp',
  AiVoice = 'aiVoice',
  AiChat = 'aiChat',
}
